import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import {ApplicationState} from '../../store';
import {Cart as CartRedux, CartTypes, ProductType} from '../../store/ducks/cart/types';
import * as CartActions from '../../store/ducks/cart/actions';
import {Param, ParamTypes} from '../../store/ducks/param/types';
import * as ParamActions from '../../store/ducks/param/actions';
import './index.scss';
import logo from '../../assets/logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope, faBorderNone} from '@fortawesome/free-solid-svg-icons'
import { faShoppingBag} from '@fortawesome/free-solid-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { isScopable } from '@babel/types';
import { isObject } from 'util';
import { Link } from 'react-router-dom';
import Api from '../../services/api';
import {Diversos} from '../../services/diversos';
  
import CartItem from '../CartItem';

//Bootstrap Components
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Badge from 'react-bootstrap/Badge'
declare var window;

interface StateProps { 
  cart: CartRedux;
  param: Param;
}

interface DispatchProps {
  add(cart: ProductType): void;
  update(cart: ProductType): void;
  drop(rowid: string): void;
  setParam(data: Param): void;
}

interface OwnProps {
} 

type Props = StateProps & DispatchProps & OwnProps;

class Cart extends Component<Props> {

  state: any = null;

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  private getCartTotal () {
    const self = this;
    let total = 0.00;
    for ( var i = 0; i < self.props.cart.produtos.length; i++ ) {
      total += self.props.cart.produtos[i].price * self.props.cart.produtos[i].qty;
    }
    return total;
  }

  private getCartAmount () {
    const self = this;
    let amount = 0;
    for ( var i = 0; i < self.props.cart.produtos.length; i++ ) {
      amount += self.props.cart.produtos[i].qty;
    }
    return amount;
  }

  private handleCheckout () {
    const self = this;
    self.props.setParam({ ...self.props.param, cartOpened: false });
    setTimeout(() => {
      window.location.href = "/checkout";
    }, 200);
  }

  render () {
    return (
      <>
        <Modal.Header closeButton className="cart-header">
          <Modal.Title className="cart-title">
            Meu Carrinho <Badge variant="light" className="items-badge">{this.getCartAmount()}</Badge>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="cart-content">

          {
            ((this.props.cart.produtos) && (this.props.cart.produtos.length <= 0)) ? 
            <div className="empty-cart">
              <h4 className="empty-cart-title"> Seu carrinho está vazio </h4>
              <p className="empty-cart-text"> Navegue por nossa loja e econtre seus produtos favoritos! </p>
              <Button variant="outline-primary" className="mt-3 btn-outlined-action cart-keep-shopping"
              onClick={() => this.props.setParam({ ...this.props.param, cartOpened: false })}> Continuar comprando </Button>
            </div> 
            :
            <>
              <div className="cart-populated">
                {
                  this.props.cart.produtos.map((row, index) => (
                    <CartItem item={row} key={index}/>
                  ))
                }
              </div>
              <Container className="cart-continue-container">
                <Row className="mt-auto">
                  <Col className="cart-continue">
                    <Row className="w-100">
                      <span>
                        <h5 className="partial-total"> SUBTOTAL: <strong> R$ {Diversos.number_format(this.getCartTotal(),2,",","")} </strong> </h5>
                      </span>
                    </Row>
                    <Row className="mb-3">
                      <Button className="btn-primary-action cart-action" onClick={this.handleCheckout.bind(this)}> Finalizar Compra </Button>
                    </Row>
                    <Row>
                      <Button className="btn-secondary-action cart-action" onClick={() => this.props.setParam({ ...this.props.param, cartOpened: false })}> Continuar comprando </Button>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </>
          }
        </Modal.Body>
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  cart: state.cart.data,
  param: state.param.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...CartActions, ...ParamActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Cart);